function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $710a952ab0d40e5e$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"fCior":"wheel.917780c7.js","1JpBc":"F.6b6d9f7c.png","5JpFe":"H.861eac15.png","4oBZe":"C.4155e805.png","ayPmu":"FH.1175a7c9.png","lfU0b":"CF.0bf185a5.png","4YbjV":"CH.e5516591.png","5TEX7":"CFH.41dd1b2b.png","2Ooy7":"beep.711e2a41.mp3","9TR4v":"tada.a948458b.mp3","8JazG":"pinball.264d2f48.mp3","j6GAN":"youshouldnotbehere.f0aefe0e.js","7xmCg":"wheel.ce67c36f.js"}'));


var $e8Ie2 = parcelRequire("e8Ie2");

var $4zpiX = parcelRequire("4zpiX");

var $hKeqt = parcelRequire("hKeqt");
var $0683e5c833be2e65$require$stringify = $hKeqt.stringify;
const $0683e5c833be2e65$var$SERVER_URL = "https://funsizeapps.b4a.app/";
const $0683e5c833be2e65$var$APP_ID = "rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9";
const $0683e5c833be2e65$var$JAVASCRIPT_KEY = "xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv";
$4zpiX.initialize($0683e5c833be2e65$var$APP_ID, $0683e5c833be2e65$var$JAVASCRIPT_KEY);
$4zpiX.serverURL = $0683e5c833be2e65$var$SERVER_URL;
var $0683e5c833be2e65$var$startC, $0683e5c833be2e65$var$startF, $0683e5c833be2e65$var$startHH, $0683e5c833be2e65$var$startButton, $0683e5c833be2e65$var$btnFilters, $0683e5c833be2e65$var$btnCancelFilters, $0683e5c833be2e65$var$btnConfirmFilters, $0683e5c833be2e65$var$btnRandomize, $0683e5c833be2e65$var$btnSelectSpot, $0683e5c833be2e65$var$btnTryAgain, $0683e5c833be2e65$var$btnGoBack, $0683e5c833be2e65$var$startModal, $0683e5c833be2e65$var$filterModal, $0683e5c833be2e65$var$resultModal, $0683e5c833be2e65$var$emptyModal, $0683e5c833be2e65$var$spotsData, $0683e5c833be2e65$var$filteredSpotData, $0683e5c833be2e65$var$randomizedSpotData, $0683e5c833be2e65$var$attributesData, $0683e5c833be2e65$var$currentlySelectedSpotIndex, $0683e5c833be2e65$var$spotCards, $0683e5c833be2e65$var$ticker, $0683e5c833be2e65$var$lottiePlayer, $0683e5c833be2e65$var$btnSnacksYes, $0683e5c833be2e65$var$btnSnacksNo;
const $0683e5c833be2e65$var$starveEmojis = [
    "☠️",
    "\uD83E\uDDB4",
    "\uD83E\uDEE0",
    "\uD83E\uDD7A",
    "\uD83E\uDD75",
    "\uD83E\uDD2C",
    "\uD83D\uDE35",
    "\uD83D\uDC80",
    "\uD83E\uDEA6",
    "⚰️"
];
var $63088cb229aafa75$exports = {};

$63088cb229aafa75$exports = new URL((parcelRequire("kyEFX")).resolve("1JpBc"), import.meta.url).toString();


var $0d49cce2ff8d5d0c$exports = {};

$0d49cce2ff8d5d0c$exports = new URL((parcelRequire("kyEFX")).resolve("5JpFe"), import.meta.url).toString();


var $f90a7ab16f210d98$exports = {};

$f90a7ab16f210d98$exports = new URL((parcelRequire("kyEFX")).resolve("4oBZe"), import.meta.url).toString();


var $55356a7496f24501$exports = {};

$55356a7496f24501$exports = new URL((parcelRequire("kyEFX")).resolve("ayPmu"), import.meta.url).toString();


var $4a3f0322b8dfd60c$exports = {};

$4a3f0322b8dfd60c$exports = new URL((parcelRequire("kyEFX")).resolve("lfU0b"), import.meta.url).toString();


var $632cd5b9717d5dc7$exports = {};

$632cd5b9717d5dc7$exports = new URL((parcelRequire("kyEFX")).resolve("4YbjV"), import.meta.url).toString();


var $489cbe7c4c5ae28f$exports = {};

$489cbe7c4c5ae28f$exports = new URL((parcelRequire("kyEFX")).resolve("5TEX7"), import.meta.url).toString();


const $0683e5c833be2e65$var$defaultImages = [
    new URL($63088cb229aafa75$exports),
    new URL($0d49cce2ff8d5d0c$exports),
    new URL($f90a7ab16f210d98$exports),
    new URL($55356a7496f24501$exports),
    new URL($4a3f0322b8dfd60c$exports),
    new URL($632cd5b9717d5dc7$exports),
    new URL($489cbe7c4c5ae28f$exports)
];
const $0683e5c833be2e65$var$options = {
    coffee: false,
    food: false,
    happyHour: false,
    indoor: false,
    outdoor: false,
    takeout: false,
    large: false,
    snacks: false
};
var $6ca9f1422228d595$exports = {};

$6ca9f1422228d595$exports = new URL((parcelRequire("kyEFX")).resolve("2Ooy7"), import.meta.url).toString();


const $0683e5c833be2e65$var$beep = new Audio(new URL($6ca9f1422228d595$exports));
var $e41a3c7fa2fdbf75$exports = {};

$e41a3c7fa2fdbf75$exports = new URL((parcelRequire("kyEFX")).resolve("9TR4v"), import.meta.url).toString();


const $0683e5c833be2e65$var$tada = new Audio(new URL($e41a3c7fa2fdbf75$exports));
var $31a9190a586dbbcf$exports = {};

$31a9190a586dbbcf$exports = new URL((parcelRequire("kyEFX")).resolve("8JazG"), import.meta.url).toString();


const $0683e5c833be2e65$var$ping = new Audio(new URL($31a9190a586dbbcf$exports));
window.addEventListener("load", ()=>{
    $0683e5c833be2e65$var$initUI();
    $0683e5c833be2e65$var$setUIState(false);
    $0683e5c833be2e65$var$getAttributes().then(()=>{
        $0683e5c833be2e65$var$getSpots().then(()=>{
            $0683e5c833be2e65$var$setUIState(true);
        }).catch(function(e) {
            console.log(e);
            $0683e5c833be2e65$var$handleParseError("Error when fetching Spots", e);
        });
    }).catch(function(e) {
        console.log(e);
        $0683e5c833be2e65$var$handleParseError("Error when fetching Attributes", e);
    });
});
const $0683e5c833be2e65$var$setUIState = (enabled)=>{
    if (enabled) {
        $0683e5c833be2e65$var$startModal.classList.remove("hidden");
        document.getElementById("first-action-bar").classList.remove("hidden");
        document.querySelector(".container").classList.remove("hidden");
        document.querySelector(".loader").classList.add("hidden");
    } else {
        $0683e5c833be2e65$var$startModal.classList.add("hidden");
        document.getElementById("first-action-bar").classList.add("hidden");
        document.querySelector(".container").classList.add("hidden");
        document.querySelector(".loader").classList.remove("hidden");
    }
};
const $0683e5c833be2e65$var$initUI = ()=>{
    //startup stuff
    $0683e5c833be2e65$var$startModal = document.getElementById("startModal");
    $0683e5c833be2e65$var$startC = document.getElementById("choiceCardCoffee");
    $0683e5c833be2e65$var$startF = document.getElementById("choiceCardFood");
    $0683e5c833be2e65$var$startHH = document.getElementById("choiceCardHH");
    $0683e5c833be2e65$var$startC.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$beep.play();
        $0683e5c833be2e65$var$startC.classList.toggle("selected");
    });
    $0683e5c833be2e65$var$startF.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$beep.play();
        $0683e5c833be2e65$var$startF.classList.toggle("selected");
    });
    $0683e5c833be2e65$var$startHH.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$beep.play();
        $0683e5c833be2e65$var$startHH.classList.toggle("selected");
    });
    $0683e5c833be2e65$var$startButton = document.getElementById("startButton");
    $0683e5c833be2e65$var$startButton.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$beep.play();
        gsap.fromTo($0683e5c833be2e65$var$startModal, {
            x: 0
        }, {
            x: -window.innerWidth,
            duration: 0.5,
            ease: "power2.out"
        });
        $0683e5c833be2e65$var$initSpotOptions();
        $0683e5c833be2e65$var$renderSpots();
    });
    //filter stuff
    $0683e5c833be2e65$var$filterModal = document.getElementById("filterModal");
    $0683e5c833be2e65$var$btnFilters = document.getElementById("btn_filters");
    $0683e5c833be2e65$var$btnCancelFilters = document.querySelector(".filters img");
    $0683e5c833be2e65$var$btnConfirmFilters = document.getElementById("filter_button");
    $0683e5c833be2e65$var$btnFilters.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$beep.play();
        $0683e5c833be2e65$var$filterModal.classList.remove("hidden");
        $0683e5c833be2e65$var$initFilterModal();
    });
    $0683e5c833be2e65$var$btnCancelFilters.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$beep.play();
        $0683e5c833be2e65$var$filterModal.classList.add("hidden");
        if ($0683e5c833be2e65$var$filteredSpotData.length < 1) $0683e5c833be2e65$var$emptyModal.classList.remove("hidden");
    });
    $0683e5c833be2e65$var$btnConfirmFilters.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$beep.play();
        $0683e5c833be2e65$var$filterModal.classList.add("hidden");
        $0683e5c833be2e65$var$updateSpotOptions();
        $0683e5c833be2e65$var$renderSpots();
    });
    $0683e5c833be2e65$var$btnSnacksYes = document.getElementById("snacks_y");
    $0683e5c833be2e65$var$btnSnacksYes.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$btnSnacksYes.classList.toggle("snack-selected");
        $0683e5c833be2e65$var$btnSnacksNo.classList.toggle("snack-selected");
    });
    $0683e5c833be2e65$var$btnSnacksNo = document.getElementById("snacks_n");
    $0683e5c833be2e65$var$btnSnacksNo.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$btnSnacksYes.classList.toggle("snack-selected");
        $0683e5c833be2e65$var$btnSnacksNo.classList.toggle("snack-selected");
    });
    //main ui stuff
    $0683e5c833be2e65$var$spotCards = document.querySelector(".card-wrapper").children;
    $0683e5c833be2e65$var$btnRandomize = document.getElementById("btn_randomize");
    $0683e5c833be2e65$var$btnRandomize.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$beep.play();
        $0683e5c833be2e65$var$renderSpots();
    });
    $0683e5c833be2e65$var$btnSelectSpot = document.getElementById("btn_pick");
    $0683e5c833be2e65$var$btnSelectSpot.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$beep.play();
        $0683e5c833be2e65$var$pickASpot();
    });
    //results stuff
    $0683e5c833be2e65$var$resultModal = document.getElementById("resultsModal");
    $0683e5c833be2e65$var$btnTryAgain = document.getElementById("btn_tryAgain");
    $0683e5c833be2e65$var$btnTryAgain.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$beep.play();
        $0683e5c833be2e65$var$spotCards[$0683e5c833be2e65$var$currentlySelectedSpotIndex].classList.remove("card-active");
        gsap.fromTo($0683e5c833be2e65$var$resultModal, {
            x: 0
        }, {
            x: -window.innerWidth,
            duration: 0.75,
            ease: "expo.out(1, 0.5)",
            onComplete: ()=>{
                $0683e5c833be2e65$var$resultModal.classList.add("hidden");
            }
        });
    });
    $0683e5c833be2e65$var$lottiePlayer = document.getElementById("lottie");
    //empty stuff
    $0683e5c833be2e65$var$emptyModal = document.getElementById("emptyModal");
    $0683e5c833be2e65$var$btnGoBack = document.getElementById("btn_goBack");
    $0683e5c833be2e65$var$btnGoBack.addEventListener("click", ()=>{
        $0683e5c833be2e65$var$initFilterModal();
        $0683e5c833be2e65$var$emptyModal.classList.add("hidden");
        $0683e5c833be2e65$var$filterModal.classList.remove("hidden");
    });
};
const $0683e5c833be2e65$var$initSpotOptions = ()=>{
    $0683e5c833be2e65$var$filteredSpotData = $0683e5c833be2e65$var$spotsData;
    if ($0683e5c833be2e65$var$startC.classList.contains("selected")) $0683e5c833be2e65$var$filteredSpotData = $0683e5c833be2e65$var$filteredSpotData.filter((s)=>{
        return s.get("Category").includes($0683e5c833be2e65$var$startC.dataset.value);
    });
    if ($0683e5c833be2e65$var$startF.classList.contains("selected")) $0683e5c833be2e65$var$filteredSpotData = $0683e5c833be2e65$var$filteredSpotData.filter((s)=>{
        return s.get("Category").includes($0683e5c833be2e65$var$startF.dataset.value);
    });
    if ($0683e5c833be2e65$var$startHH.classList.contains("selected")) $0683e5c833be2e65$var$filteredSpotData = $0683e5c833be2e65$var$filteredSpotData.filter((s)=>{
        return s.get("Category").includes($0683e5c833be2e65$var$startHH.dataset.value);
    });
    $0683e5c833be2e65$var$options.coffee = $0683e5c833be2e65$var$startC.classList.contains("selected");
    $0683e5c833be2e65$var$options.food = $0683e5c833be2e65$var$startF.classList.contains("selected");
    $0683e5c833be2e65$var$options.happyHour = $0683e5c833be2e65$var$startHH.classList.contains("selected");
};
const $0683e5c833be2e65$var$updateSpotOptions = ()=>{
    $0683e5c833be2e65$var$filteredSpotData = $0683e5c833be2e65$var$spotsData;
    [
        ...document.getElementById("filter_cats").options
    ].forEach(function(element) {
        if (element.selected) $0683e5c833be2e65$var$filteredSpotData = $0683e5c833be2e65$var$filteredSpotData.filter((s)=>{
            return s.get("Category").includes(element.value);
        });
        if (element.text.startsWith("F")) $0683e5c833be2e65$var$options.food = element.selected;
        else if (element.text.startsWith("C")) $0683e5c833be2e65$var$options.coffee = element.selected;
        else $0683e5c833be2e65$var$options.happyHour = element.selected;
    });
    if ($0683e5c833be2e65$var$btnSnacksYes.classList.contains("snack-selected")) $0683e5c833be2e65$var$filteredSpotData = $0683e5c833be2e65$var$filteredSpotData.filter((s)=>{
        return s.get("HasSnacks") == true;
    });
    $0683e5c833be2e65$var$options.snacks = $0683e5c833be2e65$var$btnSnacksYes.classList.contains("snack-selected");
    [
        ...document.getElementById("filter_sets").options
    ].forEach(function(element) {
        if (element.selected) $0683e5c833be2e65$var$filteredSpotData = $0683e5c833be2e65$var$filteredSpotData.filter((s)=>{
            return s.get("Setting").includes(element.value);
        });
        if (element.text.startsWith("I")) $0683e5c833be2e65$var$options.indoor = element.selected;
        else if (element.text.startsWith("O")) $0683e5c833be2e65$var$options.outdoor = element.selected;
        else $0683e5c833be2e65$var$options.takeout = element.selected;
    });
    if (document.getElementById("large_y").selected) $0683e5c833be2e65$var$filteredSpotData = $0683e5c833be2e65$var$filteredSpotData.filter((s)=>{
        return s.get("LargeParties") == true;
    });
    $0683e5c833be2e65$var$options.large = document.getElementById("large_y").selected;
};
const $0683e5c833be2e65$var$renderSpots = ()=>{
    if ($0683e5c833be2e65$var$filteredSpotData.length < 1) {
        $0683e5c833be2e65$var$emptyModal.classList.remove("hidden");
        return;
    }
    var used = [];
    $0683e5c833be2e65$var$randomizedSpotData = [];
    if ($0683e5c833be2e65$var$filteredSpotData.length < 12) for(var i = 0; i < 12 - $0683e5c833be2e65$var$filteredSpotData.length; i++)$0683e5c833be2e65$var$randomizedSpotData.push({
        name: `Starve ${$0683e5c833be2e65$var$starveEmojis[$0683e5c833be2e65$var$randomNumber(0, $0683e5c833be2e65$var$starveEmojis.length)]}`,
        id: "starve"
    });
    while($0683e5c833be2e65$var$randomizedSpotData.length < 12){
        var n = $0683e5c833be2e65$var$randomNumber(0, $0683e5c833be2e65$var$filteredSpotData.length);
        while(used.includes(n))n = $0683e5c833be2e65$var$randomNumber(0, $0683e5c833be2e65$var$filteredSpotData.length);
        used.push(n);
        $0683e5c833be2e65$var$randomizedSpotData.push({
            name: $0683e5c833be2e65$var$filteredSpotData[n].get("Name"),
            id: $0683e5c833be2e65$var$filteredSpotData[n].id
        });
    }
    used = [];
    while(used.length < 12){
        var n = $0683e5c833be2e65$var$randomNumber(0, $0683e5c833be2e65$var$randomizedSpotData.length);
        while(used.includes(n))n = $0683e5c833be2e65$var$randomNumber(0, $0683e5c833be2e65$var$randomizedSpotData.length);
        used.push(n);
        $0683e5c833be2e65$var$spotCards[used.length - 1].dataset.id = $0683e5c833be2e65$var$randomizedSpotData[n].id;
        $0683e5c833be2e65$var$spotCards[used.length - 1].innerHTML = $0683e5c833be2e65$var$randomizedSpotData[n].name;
    }
};
const $0683e5c833be2e65$var$initFilterModal = ()=>{
    [
        ...document.getElementById("filter_cats").options
    ].forEach(function(element) {
        if (element.text.startsWith("F")) element.selected = $0683e5c833be2e65$var$options.food;
        else if (element.text.startsWith("C")) element.selected = $0683e5c833be2e65$var$options.coffee;
        else element.selected = $0683e5c833be2e65$var$options.happyHour;
    });
    [
        ...document.getElementById("filter_sets").options
    ].forEach(function(element) {
        if (element.text.startsWith("I")) element.selected = $0683e5c833be2e65$var$options.indoor;
        else if (element.text.startsWith("O")) element.selected = $0683e5c833be2e65$var$options.outdoor;
        else element.selected = $0683e5c833be2e65$var$options.takeout;
    });
    document.getElementById("large_y").selected = $0683e5c833be2e65$var$options.large;
    document.getElementById("large_n").selected = !$0683e5c833be2e65$var$options.large;
    if ($0683e5c833be2e65$var$options.snacks) {
        $0683e5c833be2e65$var$btnSnacksYes.classList.add("snacks-selected");
        $0683e5c833be2e65$var$btnSnacksNo.classList.remove("snacks-selected");
    } else {
        $0683e5c833be2e65$var$btnSnacksYes.classList.remove("snacks-selected");
        $0683e5c833be2e65$var$btnSnacksNo.classList.add("snacks-selected");
    }
};
const $0683e5c833be2e65$var$setRandomSpot = ()=>{
    if ($0683e5c833be2e65$var$currentlySelectedSpotIndex) $0683e5c833be2e65$var$spotCards[$0683e5c833be2e65$var$currentlySelectedSpotIndex].classList.remove("card-active");
    var n = $0683e5c833be2e65$var$randomNumber(1, $0683e5c833be2e65$var$randomizedSpotData.length);
    while(n == $0683e5c833be2e65$var$currentlySelectedSpotIndex)n = $0683e5c833be2e65$var$randomNumber(1, $0683e5c833be2e65$var$randomizedSpotData.length);
    $0683e5c833be2e65$var$currentlySelectedSpotIndex = n;
    $0683e5c833be2e65$var$spotCards[$0683e5c833be2e65$var$currentlySelectedSpotIndex].classList.add("card-active");
};
const $0683e5c833be2e65$var$startSelectingSpots = (stop)=>{
    $0683e5c833be2e65$var$ping.play();
    $0683e5c833be2e65$var$setRandomSpot();
    if (stop) {
        while($0683e5c833be2e65$var$spotCards[$0683e5c833be2e65$var$currentlySelectedSpotIndex].dataset.id == "starve")$0683e5c833be2e65$var$setRandomSpot();
        window.setTimeout(()=>{
            $0683e5c833be2e65$var$handleSuccess();
        }, 1000);
    }
};
//picker animation
const $0683e5c833be2e65$var$pickASpot = ()=>{
    $0683e5c833be2e65$var$ticker = 0;
    $0683e5c833be2e65$var$startSelectingSpots(false);
    gsap.to(".container", {
        opacity: 1,
        duration: 5,
        ease: "power2.out",
        onUpdate: ()=>{
            $0683e5c833be2e65$var$ticker++;
            if ($0683e5c833be2e65$var$ticker % 10 == 0) $0683e5c833be2e65$var$startSelectingSpots(false);
        },
        onComplete: ()=>{
            $0683e5c833be2e65$var$startSelectingSpots(true);
        }
    });
};
const $0683e5c833be2e65$var$handleSuccess = ()=>{
    const spot = $0683e5c833be2e65$var$spotsData.filter((s)=>{
        return s.id == $0683e5c833be2e65$var$spotCards[$0683e5c833be2e65$var$currentlySelectedSpotIndex].dataset.id;
    })[0];
    const spotOptions = spot.get("Category");
    $0683e5c833be2e65$var$resultModal.classList.remove("hidden");
    gsap.fromTo($0683e5c833be2e65$var$resultModal, {
        x: window.innerWidth
    }, {
        x: 0,
        duration: 0.5,
        ease: "expo.out(1, 0.5)"
    });
    document.getElementById("winner_name").innerHTML = spot.get("Name");
    const item = document.getElementById("winner_img");
    if (!spot.get("Image")) {
        if (spotOptions.includes($0683e5c833be2e65$var$startC.dataset.value) && spotOptions.includes($0683e5c833be2e65$var$startF.dataset.value) && spotOptions.includes($0683e5c833be2e65$var$startHH.dataset.value)) input.src = $0683e5c833be2e65$var$defaultImages[6];
        else if (spotOptions.includes($0683e5c833be2e65$var$startC.dataset.value) && spotOptions.includes($0683e5c833be2e65$var$startF.dataset.value)) item.src = $0683e5c833be2e65$var$defaultImages[4];
        else if (spotOptions.includes($0683e5c833be2e65$var$startC.dataset.value) && spotOptions.includes($0683e5c833be2e65$var$startHH.dataset.value)) item.src = $0683e5c833be2e65$var$defaultImages[5];
        else if (spotOptions.includes($0683e5c833be2e65$var$startF.dataset.value) && spotOptions.includes($0683e5c833be2e65$var$startHH.dataset.value)) item.src = $0683e5c833be2e65$var$defaultImages[3];
        else if (spotOptions.includes($0683e5c833be2e65$var$startF.dataset.value)) item.src = $0683e5c833be2e65$var$defaultImages[0];
        else if (spotOptions.includes($0683e5c833be2e65$var$startC.dataset.value)) item.src = $0683e5c833be2e65$var$defaultImages[2];
        else item.src = $0683e5c833be2e65$var$defaultImages[1];
    } else item.src = spot.get("Image").url();
    if (spot.get("Quote")) {
        document.querySelector(".quote-wrapper").classList.remove("hidden");
        document.getElementById("winner_quote").innerHTML = spot.get("Quote").length > 0 ? `"${spot.get("Quote").replace(new RegExp('"', "g"), "")}"` : "";
        if (spot.get("Quotee")) document.getElementById("winner_quotee").innerHTML = spot.get("Quotee");
    } else document.querySelector(".quote-wrapper").classList.add("hidden");
    document.getElementById("winner_address").innerHTML = spot.get("Address");
    document.getElementById("winner_address").href = spot.get("MapUrl");
    if (spot.get("WebsiteUrl")) {
        const menu = document.getElementById("winner_menu");
        menu.classList.remove("hidden");
        menu.href = spot.get("WebsiteUrl");
        menu.innerHTML = spot.get("WebsiteUrl").replace("https://www.", "").replace(".com/", ".com");
    } else document.getElementById("winner_menu").classList.add("hidden");
    $0683e5c833be2e65$var$tada.play();
    $0683e5c833be2e65$var$lottiePlayer.load((0, (/*@__PURE__*/$parcel$interopDefault($e8Ie2))));
};
async function $0683e5c833be2e65$var$getSpots() {
    const query = new $4zpiX.Query("WheelSpot");
    query.ascending("Name");
    try {
        $0683e5c833be2e65$var$spotsData = await query.find();
    } catch (error) {
        throw error;
    }
}
async function $0683e5c833be2e65$var$getAttributes() {
    const query = new $4zpiX.Query("WheelSpotAttribute");
    try {
        $0683e5c833be2e65$var$attributesData = await query.find();
        var input1 = document.getElementById("filter_cats");
        const categories = $0683e5c833be2e65$var$attributesData.filter((a)=>a.get("Type") == "Category");
        categories.forEach((c)=>{
            const o = document.createElement("option");
            o.text = c.get("Value");
            o.value = c.id;
            input1.add(o);
            if (c.get("Value") === "Coffee") $0683e5c833be2e65$var$startC.dataset.value = c.id;
            else if (c.get("Value") === "Food") $0683e5c833be2e65$var$startF.dataset.value = c.id;
            else $0683e5c833be2e65$var$startHH.dataset.value = c.id;
        });
        [
            ...input1.options
        ].forEach(function(element) {
            element.addEventListener("mousedown", function(e) {
                e.preventDefault();
                element.parentElement.focus();
                this.selected = !this.selected;
                return false;
            }, false);
        });
        input1 = document.getElementById("filter_sets");
        const settings = $0683e5c833be2e65$var$attributesData.filter((a)=>a.get("Type") == "Setting");
        settings.forEach((c)=>{
            const o = document.createElement("option");
            o.text = c.get("Value");
            o.value = c.id;
            input1.add(o);
        });
        [
            ...input1.options
        ].forEach(function(element) {
            element.addEventListener("mousedown", function(e) {
                e.preventDefault();
                element.parentElement.focus();
                this.selected = !this.selected;
                return false;
            }, false);
        });
    } catch (error) {
        throw error;
    }
}
function $0683e5c833be2e65$var$randomNumber(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}
function $0683e5c833be2e65$var$handleParseError(msg, err) {
    switch(err.code){
        case $4zpiX.Error.INVALID_SESSION_TOKEN:
            $4zpiX.User.logOut();
            window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
            break;
        default:
            console.log(`${msg} : ${err.code} - ${err.message}`);
    }
}


//# sourceMappingURL=wheel.917780c7.js.map
